"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var justifyContentMap = {
    start: 'flex-start',
    center: 'center',
    end: 'flex-end',
    between: 'space-between',
    around: 'space-around',
    stretch: 'stretch',
};
// eslint-disable-next-line no-confusing-arrow
exports.default = (function (_a) {
    var justifyContent = _a.justifyContent;
    return justifyContent in justifyContentMap ? "justify-content: " + justifyContentMap[justifyContent] + ";" : '';
});
